import { Map } from 'immutable'
// import { DataType } from './types'

export const DataRecord = Map
